import React, {Component} from 'react';
import Reactable from 'reactable';

import ApiService from './ApiService';

function getDisplayDate(fullDate) {
  let [, month, date] = fullDate.toDateString().split(` `);
  return `${date} ${month}`;
}

/**
 * Class for log.
 *
 * @class      Log (name)
 */
class Log extends Component {

  constructor(props) {
    super(props);

    this.state = {
      logs: [],
      loading: true,
    };
  }

  componentWillMount() {
    ApiService.loadJSON(__API_URL__ + `/admin/logs`)
      .then(logs => {
        this.setState({
          logs,
          loading: false,
        });
      });
  }
  
  addEmailFilter(event) {
    this.setState({
      emailFilter: event.target.value,
    });
  }

  addTempleFilter(event) {
    this.setState({
      templeFilter: event.target.value,
    });
  }

  render() {

    let logs = this.state.logs;
    const Table = Reactable.Table,
      Thead = Reactable.Thead,
      Th = Reactable.Th,
      Tr = Reactable.Tr,
      Td = Reactable.Td;

    let emails = {}, temples = {};

    // email/temple are null on a log entry whose user or temple was later
    // deleted (change_log.user_email/temple_id are ON DELETE SET NULL, so
    // the entry itself survives - see api/models/migrations/001_init.sql)
    logs.forEach(log => {
      if (log.email) emails[log.email] = true;
      if (log.temple) temples[log.temple] = true;
    });

    emails = Object.keys(emails);
    temples = Object.keys(temples);

    const templeFilter = this.state.templeFilter;
    const emailFilter = this.state.emailFilter;

    logs = logs.filter(log => {
      if (templeFilter && (!log.temple || log.temple.indexOf(templeFilter) < 0)) return false;
      if (emailFilter && (!log.email || log.email.indexOf(emailFilter) < 0)) return false;
      return true;
    });

    return (
      <div className="dashboard-log-cont container-fluid">

        <div className="filters-cont row">
          <div className="filter-icon col-xs-2 ">
            <span className="fa fa-filter"></span>
          </div>
          <div className="col-xs-5">
            <select className="form-control" onChange={this.addTempleFilter.bind(this)}>
              <option value="">Temple</option>
              {
                temples.map(temple => (
                  <option key={temple} value={temple}>{temple}</option>
                ))
              }
            </select>
          </div>
          <div className="col-xs-5">

            <select className="form-control" onChange={this.addEmailFilter.bind(this)}>
              <option value="">Email</option>
              {
                emails.map(email => (
                  <option key={email} value={email}>{email}</option>
                ))
              }
            </select>
          </div>
        </div>
        
        <div className="logs-cont row">
          
          {
            this.state.loading && (<div className="loader dark small"></div>) 
          }
          { 
            !this.state.loading && (
              <Table class="logs-table table table-bordered table-striped"
                sortable={[
                  {
                    column: `date`,
                    sortFunction: (a, b) => {
                      return a.getTime() - b.getTime();
                    },
                  },
                  `email`,
                  `temple`,
                  `action`,
                ]}
                defaultSort={{column: `temple`, direction: `asc`}} >
                <Thead>
                  <Th column="date">Date</Th>
                  <Th column="email">Email</Th>
                  <Th column="temple">Temple</Th>
                  <Th column="action">Action</Th>
                </Thead>

                {
                  logs.map(log => (
                    <Tr>
                      <Td column="date" value={new Date(log.date)}>{getDisplayDate(new Date(log.date))}</Td>
                      <Td column="email">{log.email}</Td>
                      <Td column="temple">{log.temple}</Td>
                      <Td column="action">{log.action}</Td>
                    </Tr>
                  ))
                }

              </Table>)
          }


        </div>

      </div>
    );
  }
}

export default Log;



// WEBPACK FOOTER //
// ./js/Log.js